<template>
  <div class="wrap">
    <div class="title"><span>新增角色</span></div>
    <div class="nav-bar">
      <div
        @click="changeNav(i)"
        :class="{ 'nav-item': true, selected: activeIndex == i }"
        v-for="(item, i) in navList"
        :key="i"
      >
        {{ item }}
      </div>
    </div>
    <div class="content">
      <el-form
        v-if="activeIndex == 0"
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="ruleForm"
      >
        <el-form-item label="名称：" prop="name">
          <el-input
            placeholder="请输入角色名称"
            v-model="ruleForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述：" prop="desc" required>
          <el-input
            type="textarea"
            placeholder="请输入角色描述"
            v-model="ruleForm.desc"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button>返回</el-button>
        </el-form-item>
      </el-form>
      <div v-else>
        <treeList
          :data="menuTree"
          :props="props"
          :nodeKey="'deptId'"
          @click="getCurrentKey"
          :highight="true"
          style="margin-top: 13px; background: #f0f2f5"
        />
      </div>
    </div>
  </div>
</template>

<script>
import treeList from "@/components/tree/index";
import Bus from "./Bus.js";
export default {
  components: {
    treeList
  },
  data() {
    return {
      Bus,
      ruleForm: {
        name: "",
        desc: ""
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }]
      },
      navList: ["角色信息", "角色权限配置"],
      activeIndex: 0,
      menuTree: [], //树形
      props: {
        label: "deptName",
        children: "children"
      },
      deptList: []
    };
  },
  methods: {
    changeNav(index) {
      this.activeIndex = index;
    },
    getCurrentKey() {},
    onSubmit() {}
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  background-color: #ffffff;
  height: 100%;
  .title {
    padding: 0 32px;
    height: 68px;
    line-height: 68px;
    color: #333333;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 1px solid #e8e8e8;
    box-sizing: border-box;
  }
  .content {
    padding: 32px;
    /deep/ .el-form-item__label {
      font-size: 14px;
      color: #51627d;
    }
  }
  .nav-bar {
    margin: 32px 32px 12px 32px;
    display: flex;
    height: 38px;
    width: 344px;
    .nav-item {
      border: 1px solid rgba(217, 217, 217, 1);
      box-sizing: border-box;
      width: 172px;
      font-size: 14px;
      height: 38px;
      line-height: 38px;
      color: #999999;
      background-color: #f7f7f7;
      text-align: center;
    }
    .nav-item:nth-child(1) {
      border-radius: 4px 0px 0px 4px;
    }
    .nav-item:last-child {
      border-radius: 0px 4px 4px 0px;
    }
    .selected {
      color: #ffffff;
      font-weight: bold;
      background-color: #1890ff;
      border: none;
    }
  }
}
</style>
